import {
  ACCENT_MODES,
  BRAND_STYLES,
  DEFAULT_BRAND_COLOR,
  DEFAULT_BRAND_SHADE,
  getBrandColor,
  getBrandHex
} from 'lib/constants/brandPalette';

export const isTwoColor = (draft) => draft?.style === BRAND_STYLES.TWO;

export const getEffectiveAccent = (draft) =>
  draft.accent_mode === ACCENT_MODES.CUSTOM
    ? { key: draft.accent_color, shade: draft.accent_shade }
    : { key: getBrandColor(draft.main_color).recommendedAccent, shade: draft.main_shade };

// Patient-facing screens only read `primary_color` / `secondary_color`; the picker fields
// ride along so the modal can be reopened on the same selection.
export const resolveBranding = (draft) => {
  const primary = getBrandHex(draft.main_color, draft.main_shade);
  const accent = getEffectiveAccent(draft);
  const secondary = isTwoColor(draft) ? getBrandHex(accent.key, accent.shade) : primary;
  return { ...draft, primary_color: primary, secondary_color: secondary };
};

export const isDefaultBranding = (draft) =>
  !isTwoColor(draft) &&
  draft.main_color === DEFAULT_BRAND_COLOR &&
  draft.main_shade === DEFAULT_BRAND_SHADE;

// The default look is stored as "no branding" so patient-facing screens fall back to the stock
// Myriad theme.
const toSavedBranding = (draft) => (isDefaultBranding(draft) ? null : resolveBranding(draft));

export const withBranding = (displaySettings, draft) => {
  const { branding: _branding, ...rest } = displaySettings || {};
  const branding = toSavedBranding(draft);
  return branding ? { ...rest, branding } : rest;
};

export const isSameBranding = (draft, otherDraft) =>
  JSON.stringify(toSavedBranding(draft)) === JSON.stringify(toSavedBranding(otherDraft));
